import classNames from 'classnames';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';

export const StatCard = ({
  icon,
  title,
  value,
  secondaryValue,
  dateRange,
  isLoading,
  className = '',
}: {
  icon?: React.JSX.Element;
  title?: string;
  value: string;
  dateRange: string;
  isLoading: boolean;
  secondaryValue?: string;
  className?: string;
}) => (
  <div className={classNames('flex min-w-[200px] flex-col gap-y-1 md:gap-y-2', className)}>
    {icon && title && (
      <div className="flex items-center gap-x-1 font-aeonikMedium text-12 text-cf-light-2">
        {icon}
        {title}
      </div>
    )}

    <div className="flex flex-nowrap items-center">
      {isLoading ? (
        <SkeletonLine width={125} height={26} />
      ) : (
        <>
          <span className="font-aeonikMedium text-14 text-white md:text-20">{value}</span>
          {secondaryValue && (
            <span className="whitespace-pre-wrap font-aeonikMedium text-12 text-cf-light-2">
              {' '}
              / {secondaryValue}
            </span>
          )}
        </>
      )}
    </div>
    <span className="hidden text-12 text-cf-light-3 md:block">{dateRange}</span>
  </div>
);
